import React from 'react';
import { Input } from '../../../components/ui/input';
import { Textarea } from '../../../components/ui/textarea';
import FormSection from './FormSection';
import FormField from './FormField';
import GeoActionRow from './GeoActionRow';
import LocationPreviewCard from './LocationPreviewCard';

const inputClassName = 'border-0 bg-[rgba(10,17,28,0.82)] text-[#d5e4f4] focus-visible:ring-2 focus-visible:ring-emerald-300/35';

export default function LocationFieldGroup({
  address,
  latitude,
  longitude,
  onAddressChange,
  onLatitudeChange,
  onLongitudeChange,
  addressError = '',
  latitudeError = '',
  longitudeError = '',
  onGetCurrentLocation,
  onPickOnMap,
  isLocating = false,
  geoHint = '',
  className = '',
}) {
  return (
    <FormSection title="Lokasi Instalasi" description="Alamat, koordinat, dan validasi titik instalasi." className={className}>
      <div className="grid gap-3 md:grid-cols-2">
        <FormField label="Alamat Instalasi" required error={addressError} className="md:col-span-2">
          <Textarea rows={3} value={address} onChange={(event) => onAddressChange?.(event.target.value)} className={inputClassName} />
        </FormField>
        <FormField label="Latitude" error={latitudeError}>
          <Input value={latitude} onChange={(event) => onLatitudeChange?.(event.target.value)} className={`${inputClassName} font-mono`} />
        </FormField>
        <FormField label="Longitude" error={longitudeError}>
          <Input value={longitude} onChange={(event) => onLongitudeChange?.(event.target.value)} className={`${inputClassName} font-mono`} />
        </FormField>
        <div className="md:col-span-2">
          <GeoActionRow
            onGetCurrentLocation={onGetCurrentLocation}
            onPickOnMap={onPickOnMap}
            isLocating={isLocating}
            hint={geoHint}
          />
        </div>
        <div className="md:col-span-2">
          <LocationPreviewCard latitude={latitude} longitude={longitude} title="Pratinjau Titik Instalasi" />
        </div>
      </div>
    </FormSection>
  );
}

